import React from 'react'
import PropTypes from 'prop-types'
import { SvgIcon } from '@material-ui/core/'
import { mdiAccountRemove } from '@mdi/js'

import ConfirmationDialog from '../../controls/ConfirmationDialog'
import TooltipIconButton from '../../controls/TooltipIconButton'

class DeleteUsersButton extends React.Component {
  static propTypes = {
    confirmationText: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired,
    tooltipTitle: PropTypes.node.isRequired,
  }

  state = {
    showConfirmationDialog: false,
  }

  handleButtonClick = () => {
    this.setState({ showConfirmationDialog: true })
  }

  handleDeleteConfirmed = () => {
    this.props.onDelete()
    this.handleConfirmationClose()
  }

  handleConfirmationClose = () => {
    this.setState({ showConfirmationDialog: false })
  }

  render() {
    return (
      <>
        <TooltipIconButton
          color="primary"
          onClick={this.handleButtonClick}
          tooltipTitle={this.props.tooltipTitle}
          variant="contained"
        >
          <SvgIcon>
            <path d={mdiAccountRemove} />
          </SvgIcon>
        </TooltipIconButton>

        <ConfirmationDialog
          open={this.state.showConfirmationDialog}
          title="Confirm User Deletion"
          description={this.props.confirmationText}
          confirmText="Delete"
          onCancel={this.handleConfirmationClose}
          onConfirm={this.handleDeleteConfirmed}
        />
      </>
    )
  }
}

export default DeleteUsersButton
